import React from "react";
import { DashboardVisual } from "./components/DashboardVisual";
import { DashboardModulePresentation, DashboardPanelDefinition } from "./types";

const registrations = new Map<string, DashboardModulePresentation>();

export const registerDashboardPresentation = (
  presentation: DashboardModulePresentation,
): (() => void) => {
  registrations.set(presentation.module_id, presentation);
  return () => {
    if (registrations.get(presentation.module_id) === presentation) {
      registrations.delete(presentation.module_id);
    }
  };
};

const renderGeneric = (panel: DashboardPanelDefinition, data: unknown) => {
  const visualData =
    panel.unit &&
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    !("unit" in data)
      ? { ...data, unit: panel.unit }
      : data;
  return <DashboardVisual kind={panel.kind} data={visualData} />;
};

const genericPresentation: DashboardModulePresentation = {
  module_id: "*",
  detail_route: "/organization/settings/dashboards/{module_id}",
  render_overview: renderGeneric,
  render_detail: renderGeneric,
};

export const getDashboardPresentation = (
  moduleId: string,
): DashboardModulePresentation =>
  registrations.get(moduleId) ?? genericPresentation;

export const clearDashboardPresentationsForTests = () => registrations.clear();
